import assert from 'minimalistic-assert';
const createTransactionSignerApi = ({ transactionSigner, walletAccountsAtom, }) => {
    const getWalletAccount = async (name) => {
        const walletAccounts = await walletAccountsAtom.get();
        const walletAccount = walletAccounts[name];
        assert(walletAccount, `Unknown wallet account: ${name}`);
        return walletAccount;
    };
    return {
        transactionSigner: {
            signTransaction: async (params) => {
                const walletAccount = typeof params.walletAccount === 'string'
                    ? await getWalletAccount(params.walletAccount)
                    : params.walletAccount;
                return transactionSigner.signTransaction({ ...params, walletAccount });
            },
        },
    };
};
const transactionSignerApiDefinition = {
    id: 'transactionSignerApi',
    type: 'api',
    factory: createTransactionSignerApi,
    dependencies: ['transactionSigner', 'walletAccountsAtom'],
};
export default transactionSignerApiDefinition;
